import React, { useRef, useEffect } from 'react';
import { FiSend } from 'react-icons/fi';
import Tooltip from '@mui/material/Tooltip';
import { IoMdLock } from 'react-icons/io';
import { MdOutlinePublic } from 'react-icons/md';

const ChatInput = ({ message, setMessage, addComment, isPublic, handlePrivatePublic }) => {
    const textareaRef = useRef(null);

    // Auto-resize textarea
    useEffect(() => {
        if (textareaRef.current) {
            textareaRef.current.style.height = 'auto';
            textareaRef.current.style.height = `${Math.min(textareaRef.current.scrollHeight, 100)}px`;
        }
    }, [message]);

    return (
        <div className="w-full bg-white rounded-md">
            <div className="relative border rounded-md px-4 py-2 bg-white">
                <textarea
                    ref={textareaRef}
                    rows={1}
                    className="w-full resize-none bg-transparent text-sm placeholder-gray-500 focus:outline-none pr-16"
                    placeholder="Type your comment here"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    style={{ maxHeight: '100px', minHeight: '40px' }}
                />

                {/* Icons at bottom right */}
                <div className="absolute right-3 bottom-2 flex items-center space-x-2 bg-white">
                    {isPublic ? (
                        <Tooltip title="Click to switch to private comment" placement="top" arrow>
                            <span>
                                <MdOutlinePublic
                                    className="w-6 h-6 cursor-pointer primaryIcon"
                                    onClick={() => handlePrivatePublic(false)}
                                />
                            </span>
                        </Tooltip>
                    ) : (
                        <Tooltip title="Click to switch to public comment" placement="top" arrow>
                            <span>
                                <IoMdLock
                                    className="w-6 h-6 cursor-pointer secondaryIcon"
                                    onClick={() => handlePrivatePublic(true)}
                                />
                            </span>
                        </Tooltip>
                    )}
                    <Tooltip title="Add comment" placement="top" arrow>
                        <button
                            onClick={() => addComment(message, isPublic)}
                            className="focus:outline-none chatBotSentIcon"
                        >
                            <FiSend className="w-4 h-4 pr-0.5 text-white" />
                        </button>
                    </Tooltip>
                </div>
            </div>
        </div>
    );
};

export default ChatInput;
